import React, { FC, ReactNode, memo } from 'react';
import { Link as ReactLink } from 'react-router';

import { LinkVariant, Size } from '@constants/common/ui.constants';

import useStyles from './styles.module';

interface Props {
  title: string;
  href: string;
  newTab?: boolean;
  id?: string;
  size?: Size;
  variant?: LinkVariant;
  icon?: ReactNode;
  isUnderline?: boolean;
  inLine?: boolean;
}

const Link: FC<Props> = ({
  href,
  title,
  id,
  icon,
  newTab = false,
  variant = LinkVariant.Primary,
  size = Size.Medium,
  isUnderline = true,
  inLine = false,
}) => {
  const { classes } = useStyles({
    variant,
    size,
    isUnderline,
    inLine,
  });

  return (
    <div key={title} id={id} className={classes.box}>
      {newTab ? (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className={classes.linkItem}
        >
          {title}
          {icon && icon}
        </a>
      ) : (
        <ReactLink to={href} className={classes.linkItem}>
          {title}
        </ReactLink>
      )}
    </div>
  );
};

export default memo(Link);
